import React, { useState, useEffect } from 'react';

// ExcelJS
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

// Notistack
import { useSnackbar } from 'notistack';

// Material-UI
import { Button } from '@material-ui/core';
import { GetApp as ExportIcon } from '@material-ui/icons';

// Services
import { getSubscriptionsCollected } from 'services/requests';
import { subscriptionStatuses } from 'services/constants';
import { getAmountTTC, getFormattedDate, getLabelStatus } from 'services/helpers';

// Components
import Tooltip from 'components/tooltip';

// ----------------------------------------------------------------------------------------------- \\
// -------------------------------- COLLECTED SUBSCRIPTIONS EXPORT ------------------------------- \\
// ----------------------------------------------------------------------------------------------- \\

const CollectedSubscriptionsExport = ({ transferId, data }) => {
    const { enqueueSnackbar } = useSnackbar();

    const [state, setState] = useState({
        loading: false,
        percentage: '0%',
    });

    function getAllSubscriptionsToExport(subscriptions, offset) {
        getSubscriptionsCollected(transferId, {
            offset: offset,
            limit: data.limit,
            username: data.searchName,
        }).then(res => {
            if (res.status === 200) {

                let res_subscriptions = res.data.data.subscriptions;
                subscriptions = subscriptions.concat(res_subscriptions);

                setState({
                    ...state,
                    percentage: Math.round((100 * subscriptions.length) / data.total_count) + '%',
                });

                if (res_subscriptions.length < data.limit) {
                    createExcelFile(subscriptions);
                }
                else {
                    getAllSubscriptionsToExport(subscriptions, offset + data.limit);
                }
            }
            else {
                console.log(res);
                setState({ ...state, loading: false });
                enqueueSnackbar('Échec du téléchargement', { variant: 'error' });
            }
        });
    }

    function createExcelFile(subscriptions) {
        if (subscriptions.length === 0) {
            setState({ ...state, loading: false });
            enqueueSnackbar('Aucune donnée à exporter', { variant: 'warning' });
        }
        else {
            // Create Excel File
            var workbook = new ExcelJS.Workbook();

            // Add Worksheet to the Workbook
            var worksheet = workbook.addWorksheet('Abonnements collectés par l\'association');

            // Header
            worksheet.columns = [
                { header: 'Statut abonnement', key: 'status', width: 30 },
                { header: 'Date', key: 'date', width: 30 },
                { header: 'Utilisateur', key: 'user', width: 30 },
                { header: 'Montant abonnement', key: 'price', width: 30 },
                { header: 'Type d\'abonnement', key: 'subscription_type', width: 30 },
                { header: 'Adresse de facturation', key: 'address', width: 30 },
            ];
            worksheet.getRow(1).font = { bold: true };

            // Rows
            subscriptions.map(subscription => {
                return worksheet.addRow({
                    status: getLabelStatus(subscriptionStatuses, subscription.status),
                    date: getFormattedDate(subscription.start_date) + ' - ' + getFormattedDate(subscription.end_date),
                    user: subscription.user ? (subscription.user.first_name + ' ' + subscription.user.last_name + ' (' + subscription.user.clientCode + ')') : '',
                    price: subscription.billItem ? getAmountTTC(subscription.billItem.amount) : '',
                    subscription_type: subscription.subscriptionType ? subscription.subscriptionType.name : '',
                    address: subscription.address + ' ' + subscription.postal_code + ' ' + subscription.city + ' ' + (subscription.country ? subscription.country.name : ''),
                });
            });

            // Save Excel File
            workbook.xlsx.writeBuffer().then(buffer => saveAs(new Blob([buffer]), 'abonnements-collectes-par-assoc.xlsx'));
            setState({ ...state, loading: false });
            enqueueSnackbar('Téléchargement terminé', { variant: 'success' });
        }
    }

    // Start Export
    useEffect(() => {
        if (state.loading) {
            getAllSubscriptionsToExport([], 0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.loading]);

    return (
        <Tooltip title="Exporter sous Excel"
            item={(
                <Button
                    onClick={() => setState({ ...state, loading: true })}
                    disabled={state.loading}
                    variant="contained"
                    style={{ marginLeft: 5 }}
                >
                    {state.loading ? (
                        state.percentage
                    ) : (
                        <ExportIcon />
                    )}
                </Button>
            )}
        />
    );
};

export default CollectedSubscriptionsExport;
